<template>
  <div id="map-route" />
</template>

<script>
import mapbox from 'mapbox-gl'

import config from '@/components/config'

import mapUtils from '@/utils/mapbox'

export default {
  props: {
    geojson: { type: Object, required: true },
    routeStops: { type: Array, default: () => [] },
  },
  data() {
    return {
      map: null,
      geojsonSource: 'lines',
    }
  },
  computed: {
    center() {
      let coords = this.geojson.features?.[0].geometry.coordinates || []
      if (Array.isArray(coords[0])) coords = coords[0]
      if (Array.isArray(coords) && coords.length == 2) return coords
      return [0, 0]
    },
    lineLayer() {
      return {
        id: 'lines',
        type: 'line',
        source: this.geojsonSource,
        paint: { 'line-width': 3, 'line-color': ['get', 'color'] },
        filter: ['==', '$type', 'LineString'],
      }
    },
    lineArrowsLayer() {
      const style = {
        'text-color': ['get', 'color'],
        'text-halo-color': ['get', 'color'],
        'text-halo-width': 3,
      }
      const symbolStyle = ['interpolate', ['linear'], ['zoom']]
      const layout = {
        'symbol-placement': 'line',
        'text-field': '▶',
        'text-size': [...symbolStyle, 12, 24, 22, 60],
        'symbol-spacing': [...symbolStyle, 12, 30, 22, 160],
        'text-keep-upright': false,
      }
      return {
        id: 'routearrows',
        type: 'symbol',
        source: this.geojsonSource,
        paint: style,
        filter: ['==', '$type', 'LineString'],
        layout: layout,
      }
    },
  },
  methods: {
    getStopColor(status) {
      switch (status) {
        case 'pending':
          return '#FFBA00'
        case 'emptied':
          return '#1C9600'
        default:
          return '#FF0000'
      }
    },
  },
  mounted() {
    mapbox.accessToken = config.MAPBOX_TOKEN
    this.map = new mapbox.Map({
      container: 'map-route',
      style: 'mapbox://styles/mapbox/streets-v11',
      center: this.center,
      zoom: 9,
    })
    this.map.addControl(new mapbox.FullscreenControl())
    this.map.addControl(new mapbox.NavigationControl())

    this.map.on('load', () => {
      this.map.addSource(this.geojsonSource, {
        type: 'geojson',
        data: this.geojson,
      })

      this.map.addLayer(this.lineLayer)
      this.map.addLayer(this.lineArrowsLayer, 'waterway-label')

      const last_index = (this.routeStops?.length || 0) - 1
      this.routeStops.forEach((stop, index) => {
        if (index == 0) {
          new mapbox.Marker(mapUtils.createCustomMarkerFromMaterialIcons('location_searching', '32px'))
            .setLngLat([stop.lng, stop.lat])
            .addTo(this.map)
          return
        } else if (index == last_index) {
          new mapbox.Marker(mapUtils.createCustomMarkerFromMaterialIcons('flag', '22px'))
            .setLngLat([stop.lng, stop.lat])
            .addTo(this.map)
          return
        }

        new mapbox.Marker(mapUtils.createCustomMarkerWithLabel(this.getStopColor(stop.status), stop.position))
          .setLngLat([stop.lng, stop.lat])
          .addTo(this.map)
      })
    })
  },
}
</script>
